
//import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { useNavigate, useParams } from "react-router-dom";
//import OverlayTrigger from "react-bootstrap/OverlayTrigger";
//import Tooltip from "react-bootstrap/Tooltip";
import { getProjectByLocal, goToLink, loginLogout, RedemnessStatus } from '../projectData';
import { useEffect, useState } from 'react';
import { getUserDashboard } from '../api';

const RedemnessDashboard = () => {
    const projectData = getProjectByLocal();
    const { user_ref } = useParams();
    const navigate = useNavigate();
    const [dashboard, setDashboard] = useState()

    useEffect(() => {
        getUserDashboard({ project_key: projectData?.pkey, id: user_ref })
            .then((d) => setDashboard(d?.data))
            .catch((error) => {
                loginLogout(error.response)
            })
    }, [projectData, user_ref])

    return (
        <>
            <div className="container bg-white user_points vh-100">
                <div className="row mt-6">
                    <div className="col-md-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
                        <div className='fs-6 fw-semibold my-4 text-center'>
                            To ensure a smooth redemption process, a valid PAN card is mandatory. Please add your PAN and bank details in the app
                        </div>
                        <>
                            {dashboard ? (
                                <RedemnessStatus dashboard={dashboard} />
                            ) : (
                                <div className="text-center">
                                    <div className="spinner-border text-danger" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            )}
                        </>
                        <div className='d-flex flex-column gap-4 align-items-center my-4'>
                            <button className="btn bg-danger text-white w-75" onClick={() => goToLink(navigate, `/customer/bankpancard-details/${user_ref}`, dashboard?.kyc)}  >
                                Be Redemption Ready <i className="bi bi-chevron-right"></i>
                            </button>
                            <button className="btn bg-dark text-white w-75" onClick={() => goToLink(navigate, `/customer/redem-category`, dashboard)} >
                                I Shall Do It Later <i className="bi bi-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RedemnessDashboard